
(() => {
  const options = window.JordigiOptions;
  if (!options) return;
  const previous = options.enhanceGallery;
  options.enhanceGallery = function(Gallery, ...args) {
    previous.call(this, Gallery, ...args);
    const proto = Gallery.prototype, open = proto.open;
    proto.open = function(id, ...args) {
      const result = open.call(this, id, ...args);
      const form=this.root.querySelector('form');
      if (form && !form.querySelector('[data-install-platform]')){
        const note=document.createElement('p');note.dataset.installPlatform='';
        note.textContent='Controleer vóór je begint of je eigen HTML en JavaScript kunt plaatsen. JouwWeb vereist Pro of Business. Je wijzigingen worden op dit apparaat bewaard als je browser opslag toestaat.';
        form.prepend(note);
      }
      if (!this._jdDraftBound) {
        this._jdDraftBound = true;
        const save = event => {
          if (!event.target.closest('form') || !this.product) return;
          const key=this.product.id;
          queueMicrotask(() => {
            if (this.product?.id !== key) return;
            try { localStorage.setItem('jd-design-'+key, JSON.stringify({version:1,values:this.values})); }
            catch { const out=this.root.querySelector('.feedback'); if(out) out.textContent='Deze browser kan je ontwerp niet lokaal bewaren.'; }
          });
        };
        this.root.addEventListener('input',save);
        this.root.addEventListener('change',save);
      }
      return result;
    };
  };
})();
